import { render, staticRenderFns } from "./ConfirmationSendMessageModal.vue?vue&type=template&id=4dcf35c3&"
import script from "./ConfirmationSendMessageModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSendMessageModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports